import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { ClaimHistoryListPage } from "@/modules/order";
import { requireAuthAndPermission } from "@/utils";

const claimStatusEnum = z.enum([
  "all",
  "review",
  "reject",
  "approve",
  "payment_success",
  "on_verification",
  "payment_open",
  "payment_processing",
  "cancelled"
]);

const claimHistorySearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  status: fallback(claimStatusEnum, "all").default("all"),
  sort: fallback(z.string(), "newest").default("newest")
});

export const Route = createFileRoute("/disbursement/claim-history/")({
  validateSearch: zodValidator(claimHistorySearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Claim History"
        description="View the history of external payment claim submissions."
      />
      <ClaimHistoryListPage />
    </>
  )
});

export type ClaimHistorySearchSchema = z.infer<typeof claimHistorySearchSchema>;
